{
  "successTitle": "Überprüfe deine E-Mails",
  "successMessage": "Wir haben einen Bestätigungslink gesendet an",
  "instructions": "Klicke auf den Link in der E-Mail, um dein Konto zu bestätigen und die Registrierung abzuschließen.",
  "expiryNote": "Der Link läuft in 1 Stunde ab",
  "resendButton": "Bestätigungs-E-Mail erneut senden",
  "resendingButton": "Senden...",
  "backToLogin": "Zurück zum Login",
  "failureTitle": "Verifizierung fehlgeschlagen",
  "errors": {
    "invalidOrExpired": "Ungültiger oder abgelaufener Bestätigungslink. Bitte fordere einen neuen an.",
    "genericError": "Ein Fehler ist aufgetreten. Bitte versuche es erneut.",
    "noEmail": "Keine E-Mail-Adresse vorhanden. Bitte melde dich erneut an.",
    "resendFailed": "Verifizierungs-E-Mail konnte nicht gesendet werden. Bitte erneut versuchen."
  }
}
